export const environment = {
  production: true,
  refereapiurl:'https://devapis.globalhuntindia.com/srcs/',
 siteName:'https://www.globalhunt.in',
  source:'RefereeRef',
  redirectUrl:'https://devreferee.globalhuntindia.com/',
  domain:'.globalhuntindia.com',
  apiKey:'ydPLtMJ3pv33GdHSRvKUZ6BhP8BxKJFO7iQyVPVb'
};
